import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, map, timeout } from 'rxjs';
import {
  AccessContext,
  parseAccessContext,
} from '../interfaces/access-context';
import { RUNTIME_CONFIG } from '../config/runtime-config';

@Injectable({ providedIn: 'root' })
export class AccessContextApiService {
  // Bootstrap uses the already obtained token; the session interceptor would wait for this same request.
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly config = inject(RUNTIME_CONFIG);

  read(token: string): Promise<AccessContext> {
    return firstValueFrom(
      this.http
        .get<unknown>(
          `${new URL(this.config.keycloakUrl, location.origin).href.replace(/\/$/, '')}/realms/${encodeURIComponent(this.config.realm)}/mt-iam/profile/access`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
        .pipe(timeout(15_000), map(parseAccessContext)),
    );
  }
}
